import { useState } from 'react';
import { getUnreadNotificationCount as getUnreadNotificationCountService } from '../../../services/notification/NotificationService';
import { useDispatch } from 'react-redux';
import { setUnreadNotificationCount } from '../../../slices/user';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useUnreadNotificationCount = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  const getUnreadNotificationCount = async () => {
    try {
      const count = await getUnreadNotificationCountService();

      dispatch(setUnreadNotificationCount(count.data));
    } catch (error) {}

    setIsLoading(false);
  };

  return { getUnreadNotificationCount, isLoading };
};

export default useUnreadNotificationCount;
